import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Edit3, Trash2, FileText, Send, Clock } from 'lucide-react';
import { writingsApi } from '../../api';
import { Button, Card } from '../../components/UI';
import './Writing.css';

const WritingList = () => {
  const [writings, setWritings] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchWritings();
  }, []);

  const fetchWritings = async () => {
    try {
      const response = await writingsApi.getAll();
      setWritings(response.data);
    } catch (error) {
      console.error('Error fetching writings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleNew = async () => {
    try {
      const response = await writingsApi.create({
        title: '',
        content: '',
        status: 'draft'
      });
      navigate(`/writing/${response.data.id}`);
    } catch (error) {
      console.error('Error creating writing:', error);
    }
  };

  const handleEdit = (id) => {
    navigate(`/writing/${id}`);
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('确定要删除这篇文章吗？')) return;
    try {
      await writingsApi.delete(id);
      fetchWritings();
    } catch (error) {
      console.error('Error deleting writing:', error);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('zh-CN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="writing-list-page">
        <div className="loading-spinner" />
      </div>
    );
  }

  return (
    <div className="writing-list-page">
      <div className="page-header">
        <div>
          <h1>Writing</h1>
          <p className="page-subtitle">X 内容创作</p>
        </div>
        <Button variant="gold" onClick={handleNew}>
          <Plus size={18} />
          New Writing
        </Button>
      </div>

      {writings.length === 0 ? (
        <Card className="empty-state-card">
          <FileText size={48} />
          <h3>还没有任何文章</h3>
          <p>点击上方按钮开始创作</p>
        </Card>
      ) : (
        <div className="writings-grid">
          {writings.map(writing => (
            <Card 
              key={writing.id} 
              className="writing-card"
              onClick={() => handleEdit(writing.id)}
            >
              <div className="writing-card-header">
                <h3>{writing.title || 'Untitled'}</h3>
                <span className={`status-tag ${writing.status}`}>
                  {writing.status === 'published' ? (
                    <><Send size={12} /> Published</>
                  ) : (
                    <><Clock size={12} /> Draft</>
                  )}
                </span>
              </div>
              <p className="writing-card-preview">
                {writing.content?.substring(0, 120).replace(/[#*`\n]/g, ' ') || 'No content'}
              </p>
              <div className="writing-card-footer">
                <span className="writing-card-date">{formatDate(writing.updated_at)}</span>
                <div className="writing-card-actions">
                  <button 
                    className="icon-btn"
                    onClick={(e) => { e.stopPropagation(); handleEdit(writing.id); }}
                  >
                    <Edit3 size={16} />
                  </button>
                  <button 
                    className="icon-btn danger"
                    onClick={(e) => handleDelete(writing.id, e)}
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default WritingList;
